import type { CRMAccount } from '../../types/crm';
import { toAccountFederation, toAccountFederationSource } from '../../types/crm';
import type { Json, Tables } from '../../types/supabase';

const toJsonRecord = (value: Json | null): Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value) ? value : {};

/**
 * A raw `crm_accounts` row as the domain account. The row carries no role: who the account is for
 * us is read from `v_account_role` (`fetchAccountBadge`), never stored on the account — so `role`
 * here is a placeholder no screen shows. (Six other copies of this mapping remain: PLAN-DETTE.)
 */
export function accountFromRow(row: Tables<'crm_accounts'>): CRMAccount {
  return {
    ...row,
    role: 'prospect',
    federation: toAccountFederation(row.federation),
    federation_source: toAccountFederationSource(row.federation_source),
    custom_fields: toJsonRecord(row.custom_fields),
  };
}
